import { create as createZustand, } from 'zustand';
import { devtools } from 'zustand/middleware';
export { useStore } from 'zustand';
export { shallow } from 'zustand/shallow';
export { persist } from 'zustand/middleware';
export const createStore = (options) => (initializer) => {
    if (options.isDev) {
        const wrapped = devtools(initializer, options);
        return createZustand()(wrapped);
    }
    return createZustand()(initializer);
};
